import {
  essentialsFieldsComplete,
  locationFieldsComplete,
  photosFieldsComplete,
  pricingFieldsComplete,
  vesselDetailsFieldsComplete,
} from 'src/admin/listing-editor/utils/getListingPanelProgress';
import { EditorListing } from 'src/common/types/api/listings';

const getListingProgress = (
  listing: EditorListing,
  isImpersonatedSession: boolean = false,
): number => {
  if (!listing) return 0;

  const TAB_VALUE = 20;
  let progress = 0;

  progress += essentialsFieldsComplete(listing) ? TAB_VALUE : 0;
  progress += locationFieldsComplete(listing) ? TAB_VALUE : 0;
  progress += photosFieldsComplete(listing) ? TAB_VALUE : 0;
  progress += vesselDetailsFieldsComplete(listing) ? TAB_VALUE : 0;
  progress += pricingFieldsComplete(listing, isImpersonatedSession) ? TAB_VALUE : 0;

  return progress;
};

export default getListingProgress;

export const isListingValid = (
  listing: EditorListing,
  isImpersonatedSession: boolean = false,
): boolean => (
  getListingProgress(listing, isImpersonatedSession) === 100
);
